<template>
    <div class="d-flex w-100">

        <div class="d-flex flex-column w-50 px-2" style="min-width: 0; flex-grow: 1">
            <div v-if="Object.keys(data_country).length > 0">
                <RoundGaugeOpportunity :data_country="data_country" :chart_type="'risk'" :chartId="'roundgaugerisk'" />
            </div>

            <div v-if="this.ispartialscore" class="partialscore_text text-center mb-1">
                No sufficient data available for complete assessment.
            </div>
            <div v-if="iscritical === 1" class="embargo-wrapper text-center my-3" style="min-height: 5rem;">
                <div class="embargo_text">
                    The Global Country Risk of this country has been penalized because of the embargo measures.
                </div>
            </div>
            <div v-html="sentenceRisk" style="height:300px"
                class="autosentence_text  d-flex flex-column justify-content-center mb-1 m-4 "></div>

            <div style="height:400px" v-if="Object.keys(data_country).length > 0">
                <SolidGauge :data_country="data_country" currentChartField="risk" :chartId="'solidgaugerisk'" />
            </div>

            <h4 class="mb-2 text-center pt-5">Global Country Risk</h4>

            <CountryRiskMap v-if="unifiedData.length > 0" :map="mapRisk" :title="titleRisk" :subtitle="subtitleRisk"
                :country_zoomed="modifyCountryToAlpha2(selectedC)" />

            <div v-if="unifiedData.length > 0">
                <OpportunityVSGlobalCountryRisk :id="'opvsglorisk'" :chartData="unifiedData" :showCountry="selectedC" />
            </div>


        </div>

        <div class="d-flex flex-column w-50 px-2" style="min-width: 0; flex-grow: 1">

            <div v-if="Object.keys(data_country).length > 0">
                <RoundGaugeOpportunity :data_country="data_country" :chart_type="'opportunity'"
                    :chartId="'roundgaugeopportunity'" />
            </div>

            <div v-if="iscritical === 1" class="embargo-wrapper text-center my-3" style="min-height: 5rem;">

            </div>

            <div v-html="sentenceOpportunity" style="height:300px"
                class="autosentence_text  d-flex flex-column justify-content-center mb-1 m-4"></div>

            <div style="height:400px" v-if="Object.keys(data_country).length > 0">
                <SolidGauge :data_country="data_country" currentChartField="opportunity"
                    :chartId="'solidgaugeopportunity'" />
            </div>

            <h4 class="mb-2 text-center pt-5">Global Country Opportunity</h4>

            <CountryOpportunityMap v-if="unifiedData.length > 0" :map="mapOpportunity" :title="titleOpportunity"
                :subtitle="subtitleOpportunity" :country_zoomed="modifyCountryToAlpha2(selectedC)" />

            <div v-if="unifiedData.length > 0" style="margin-top: 30px">
                <CountryVSRegionComparison class="pt-2 mt-2" :id="'cntrvsrgn'" :data_indicator="data_indicator"
                    :data_indicator_region="data_indicator_region" :showCountry="selectedC" :chartData="unifiedData" />
            </div>

        </div>

    </div>



</template>

<script>
/* eslint-disable */
import ProgressBar from './CountryRisk.vue'
import MapWorld from './CountryMap'
import SolidGauge from './CountryBar'
import MenuDropDown from '../UI/MenuDropDown.vue'
import Indicator from './CountryIndicator'
import IndicatorPDF from './CountryIndicatorPDF.vue'
import RoundGaugeOpportunity from './CountryGauge.vue'
import IndicatorName from "../../views/app.json"
import CountryVSRegionComparison from './CountryVSRegionComparison.vue'

import CountryRiskMap from '../HomePage/CountryMap.vue'
import CountryOpportunityMap from '../HomePage/CountryOpportunityMap.vue'
import OpportunityVSGlobalCountryRisk from '../HomePage/OpportunityVSGlobalCountryRisk.vue'

import api from '@/services/api'
import { countryToAlpha2 } from "country-to-iso";

export default {
    components: {
        ProgressBar,
        MapWorld,
        SolidGauge,
        RoundGaugeOpportunity,
        MenuDropDown,
        Indicator,
        IndicatorPDF,
        CountryRiskMap,
        CountryOpportunityMap,
        OpportunityVSGlobalCountryRisk,
        CountryVSRegionComparison
    },
    props: {
        selectedC: {
            type: String,
            required: true,
        },
        drapeauURL: {
            type: String,
            required: false,
        },
        data_country: {
            type: Object,
            required: true,
        },
        sentenceRisk: {
            type: Object,
            required: true,
        },
        all_data_country: {
            type: Object,
            required: true,
        },
        data_indicator: {
            type: Object,
            required: true,
        },
        data_indicator_world: {
            type: Object,
            required: true,
        },
        data_indicator_region: {
            type: Object,
            required: true,
        },
        sentenceOpportunity: {
            type: String,
            required: true
        },
        iscritical: {
            type: Number,
            required: true
        }
    },
    data() {
        return {
            country: [],
            data: IndicatorName,
            tabs: [
                { name: 'glocntrrisk', nameDisplay: 'Risk', icon: 'public' },
                { name: 'opportunity', nameDisplay: 'Opportunity', icon: 'lightbulb' },
                { name: 'opvsglorisk', nameDisplay: 'Opportunity vs Risk', icon: 'balance' },
            ],
            selectedTab: 'glocntrrisk',
            mapRisk: {},
            mapOpportunity: {},
            unifiedData: []
        }
    },
    methods: {
        modifyCountryToAlpha2(countryIdOrName) {
            const originalCountryToAlpha2 = countryToAlpha2;
            if ((countryIdOrName === 'KSV') | (countryIdOrName === 'Kosovo')) {
                return 'XK';
            } else {
                return originalCountryToAlpha2(countryIdOrName);
            }
        },
        async getData() {
            try {
                const results = await api.get('/countryprofile/ALLCNT?page=home_page')
                const countries = await api.get('/countries?cnttype=REG_LIMITED')
                const data = results.data.data
                const countriesData = countries.data.data


                const filteredRisk = data.filter(d =>
                    d.symbol === "overallcountryrisk" || d.symbol === "opport"
                );


                const groupedRisk = {};
                filteredRisk.forEach(item => {
                    if (!groupedRisk[item.country_id]) {
                        groupedRisk[item.country_id] = {};
                    }
                    groupedRisk[item.country_id][item.symbol] = item.value;
                });

                const regionColors = {
                    "Asia & Oceania": "#e74c3c",
                    "Europe": "#4287f5",
                    "North Africa & Middle East": "#6d0c70",
                    "North America": "#3ce7e7",
                    "South & Central America": "#067d4d",
                    "Sub-Saharan Africa": "#b69259",
                };


                this.unifiedData = countriesData.map(country => {
                    const risks = groupedRisk[country.country_id] || {};
                    return {
                        country_id: country.country_id,
                        country_name: country.country_name,
                        region_name: country.region_name,
                        overallcountryrisk: risks["overallcountryrisk"] || null,
                        opport: risks["opport"] || null,
                        color: country.isoperation === 1
                            ? regionColors[country.region_name] || "#bdc3c7"
                            : "#bdc3c7",
                        isActive: country.isoperation,
                        isoperation: country.isoperation,
                    };
                });

                this.mapOpportunity = {};
                this.unifiedData.forEach((obj) => {
                    this.mapOpportunity[obj.country_id] = {
                        name: this.modifyCountryToAlpha2(obj.country_id),
                        opportunity: obj.opport,
                    };
                });

                this.mapRisk = {};
                this.unifiedData.forEach((obj) => {
                    this.mapRisk[obj.country_id] = {
                        name: this.modifyCountryToAlpha2(obj.country_id),
                        risk: obj.overallcountryrisk,
                    };
                });
                console.log("alright")
                console.log(this.mapRisk)
            } catch (error) {
                console.error('Erreur lors de la récupération des données:', error);
            }
        },
    },
    mounted() {
        this.getData();

    },
}
</script>
